import React, { FC, useState } from "react";
import { Input, Button, Modal, Row, Col } from "antd";
import _ from "lodash";
import MapPreview from "components/Dashboard/MessagePanel/MapPreview";
import { MapPanel } from "components/Dashboard";

const AnalyticsVideoModal: FC<{ onClose: () => void }> = ({ onClose }) => {
  const [isModalVisible, setIsModalVisible] = useState<boolean>(true);

  const handleCancel = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };
  const handleOk = () => {
    setIsModalVisible(false);
    onClose && onClose();
  };

  return (
    <Modal
      visible={isModalVisible}
      onOk={handleOk}
      onCancel={handleCancel}
      width="700px"
      className="preview-modal"
      footer={[]}
      destroyOnClose={true}
    >
      <img
        style={{ width: "100%", height: "100%" }}
        src={`/images/analytics-video.png`}
      />
    </Modal>
  );
};
export default AnalyticsVideoModal;
